// ============================================================================
// BESPOKIAN Pharmacist Cockpit - Main Layout
// Application shell with sidebar navigation
// ============================================================================

import { useEffect, useRef } from 'react';
import { Outlet } from '@tanstack/react-router';
import { useLocation } from '@tanstack/react-router';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { QueueStats } from './QueueStats';

export function Layout() {
  const location = useLocation();
  const mainRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    mainRef.current?.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname]);

  return (
    <div className="flex h-screen bg-slate-50">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-w-0">
        {/* Header */}
        <Header />

        {/* Queue Stats Bar */}
        <QueueStats />

        {/* Page Content */}
        <main ref={mainRef} className="flex-1 overflow-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
